import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography, Box, Link } from '@mui/material';
import DashnaLogo from 'assets/images/dashnaIco.svg';

const DASHNA_LOGIN_URL = 'https://app.dashna.com/login?source=metrics_shutdown';
const DASHNA_EXTERNAL_STORE_URL =
  'https://app.dashna.com/external-store-creation/a2FuaGFzb2Z0XzE=@ZGFiZDA2MGUtN2QxNi00YzBlLTgxZWUtZGNjYjIwYjJmMmQ0?source=metrics_shutdown';

const MetricsShutdown = () => {
  const handleLogin = () => {
    window.open(DASHNA_LOGIN_URL, '_blank', 'noopener,noreferrer');
  };

  const handleConnectStore = () => {
    window.open(DASHNA_EXTERNAL_STORE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      <Dialog
        open={true}
        disableEscapeKeyDown
        aria-labelledby="metrics-shutdown-title"
        aria-describedby="metrics-shutdown-description"
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '640px!important'
          }
        }}
      >
        <DialogTitle
          id="metrics-shutdown-title"
          style={{
            padding: '0',
            height: '117px',
            backgroundColor: '#5F60FF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img src={DashnaLogo} alt="Dashna" style={{ width: 56, height: 56 }} />
            <Typography variant="h2" style={{ color: '#FFFFFF', margin: 0 }}>
              Dashna
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="metrics-shutdown-description">
            <Typography variant="h2" style={{ marginBottom: '30px', marginTop: '40px' }}>
              Metrics is shutting down on October 7, 2026
            </Typography>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                Due to recent updates on Walmart&apos;s side, Metrics can no longer connect to your store.
              </Typography>
            </p>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                The <b>new Dashna app</b> works with Walmart&apos;s updated system — switch over to keep your data and reports.
              </Typography>
            </p>
            <p style={{ marginBottom: '20px' }}>
              <Typography variant="p">
                <b>Already have a Dashna account?</b>{' '}
                <Link
                  component="button"
                  type="button"
                  onClick={handleLogin}
                  sx={{ cursor: 'pointer', verticalAlign: 'baseline' }}
                >
                  Log in to continue
                </Link>
                . <br />
                <b>New to Dashna?</b>{' '}
                <Link
                  component="button"
                  type="button"
                  onClick={handleConnectStore}
                  sx={{ cursor: 'pointer', verticalAlign: 'baseline' }}
                >
                  Connect your Walmart store
                </Link>{' '}
                to get started.
              </Typography>
            </p>
          </DialogContentText>
          <DialogActions style={{ padding: '0', justifyContent: 'flex-start', gap: '12px', marginBottom: '8px' }}>
            <Button variant="contained" onClick={handleLogin} autoFocus>
              Log in to Dashna
            </Button>
            <Button variant="outlined" onClick={handleConnectStore}>
              Connect your store
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MetricsShutdown;
